<!-- 互动 -->
<template>
    <div>
      <div class="course_Discuss">
        <el-row class="content_block">
           <el-col :span="activeName =='tab_1'? 12:24">
              <el-tabs v-model="activeName" @tab-click="handleClick" style="min-height: 550px;margin-right: 20px;">
                <el-tab-pane label="讨论" name="tab_1">
                  <el-row class="tc" style="width: 100px;float: left;">
                    <el-image class="user_discuss_img" :src="user"></el-image>
                    <p class="mt10">{{problemInfo.teacherIdText}}</p>
                  </el-row>
                  <el-row style="width: calc(100% - 100px);float: left;">
                    <el-row class="m0 chatContentInfo" v-html="problemInfo.chatContent" style="line-height: 25px;min-height: 56px;">
                    </el-row>
                    <el-row class="mt20 mb20">
                      <el-col :span="12" class="font14">发表时间 ：{{problemInfo.teacherOpenCourseChatLogAddTime}}</el-col>
                      <el-col :span="12" class="t_r">
                        <el-link type="primary" class="link_login">讨论数（{{problemInfo.commentCount || 0}}）</el-link>
                      </el-col>
                    </el-row>
                  </el-row>
                  <el-row>
                    <el-input
                      type="textarea"
                      :rows="10"
                      placeholder="发布讨论内容"
                      v-model="textarea">
                    </el-input>
                  </el-row>
                  <el-row class="mt20">
                      <el-button type="primary" style="float: right;" class="pl40 pr40" @click="addComment">发 表</el-button>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="我要提问" name="tab_2">
                  <PutQuestions :courseId="courseId" v-if="activeName == 'tab_2'"></PutQuestions>
                </el-tab-pane>
                <el-tab-pane label="我要回答" name="tab_3">
                  <Answer :courseId="courseId" @onSuccess_t="onSuccess_t" v-if="activeName == 'tab_3'"></Answer>
                </el-tab-pane>
              </el-tabs>
           </el-col>
           <el-col :span="12" v-if="activeName == 'tab_1'">
             <el-row style="border: 1px solid #DEDEDE;height: 550px;">
               <el-row class="p10" style="background-color: #EFF2F7;">
                 <span class="class_img">
                   <el-image style="float: left;width: 25px;margin-right: 10px;" :src="comment"></el-image>
                 </span>
                 <span>讨论区</span>
                 <el-link type="primary" style="float: right;" @click="discussionRecord">查看历史讨论 >></el-link>
                </el-row>
                <el-row style="overflow: auto;height: calc(100% - 48px);">
                  <template v-for="(item, index) in discussList" >
                    <el-row class="tl_list" :key="index+'discussList'">
                      <el-row class="tc" style="width: 100px;float: left;height: 63px;">
                        <el-image :class="index == 0?'user_discuss_img':'user_discuss_img_'" :src="user"></el-image>
                        <p v-if="index==0" :title="item.teacherIdText" :class="(index==0?'mt10':'m0 font14')+' limit_line_one'">{{item.teacherIdText}}</p>
                        <p v-if="index!=0" :title="item.studentIdText" :class="(index==0?'mt10':'m0 font14')+' limit_line_one'">{{item.studentIdText}}</p>
                      </el-row>
                      <el-row class="listInfo_p" style="width: calc(100% - 100px);float: left;">
                        <el-row class="m0" v-html="item.chatContent" :style="'line-height: 25px;'+(index == 0?'min-height: 65px;':'min-height: 38px;')">

                        </el-row>
                        <el-row class="mt10">
                          <template v-if='index == 0'>
                            <el-col :span="12" class="font14">发表时间： {{item.teacherOpenCourseChatLogAddTime}}</el-col>
                            <!-- <el-col :span="12" class="font14 t_r">
                              <el-link type="primary" class="link_login mr10">讨论数（{{item.commentCount}}）</el-link>
                              <el-link type="danger" class="link_login" @click="delInfo(item)">删除</el-link>
                            </el-col> -->
                          </template>
                          <template v-if='index != 0'>
                            <el-col :span="12" class="font14">{{item.teacherOpenCourseChatLogAddTime}}</el-col>
                            <!-- <el-col :span="12" class="font14 t_r">
                              <el-link type="primary" class="link_login mr10" @click="lookReply(item)">回复</el-link>
                              <el-link type="danger" class="link_login" @click="delInfo(item)">删除</el-link>
                            </el-col> -->
                          </template>
                        </el-row>
                      </el-row>
                      <template v-if="index > 0" v-for="(it, inde) in item.children" >
                        <el-row class="tc" style="width: 100px;float: left;margin-top: 16px;margin-left: 70px;">
                          <el-image class="user_discuss_img_" :src="user"></el-image>
                          <p class="m0 font14" style="color: #898989;">{{it.teacherIdText}}</p>
                        </el-row>
                        <el-row  class="listInfo_p" style="width: calc(100% - 170px);float: left;margin-top: 20px;font-size:14px;color: #898989;">
                          <el-row class="m0" v-html="it.chatContent" style="line-height: 25px;min-height: 35px;">

                          </el-row>
                          <el-row class="mt10">
                            <el-col :span="12" class="font14">{{it.teacherOpenCourseChatLogAddTime}}</el-col>
                            <el-col :span="12" class="font14 t_r">&nbsp;
                              <!-- <el-link type="primary" class="link_login mr10" @click="lookReply(item)">回复</el-link> -->
                              <!-- <el-link type="danger" class="link_login" @click="delInfo(it)">删除</el-link> -->
                            </el-col>
                          </el-row>
                        </el-row>
                      </template>
                    </el-row>
                  </template>
                  <!-- <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="page"
                      :page-sizes="[8, 20, 50, 100]"
                      :page-size="limit"
                      background
                      :hide-on-single-page="true"
                      layout="sizes, prev, pager, next,jumper"
                      :total="total">
                    </el-pagination>
                  </div> -->
                </el-row>
             </el-row>
           </el-col>
        </el-row>

        <!-- 提问对话框 -->
        <el-dialog
          title="我要提问"
          :visible.sync="user_questions_show"
          width="800px"
        >
          <el-row class="mb40">
            <el-col :span="3">问题摘要：</el-col>
            <el-col :span="21" class="user_questions">
              <el-row v-html="questionsInfo.chatContent"></el-row>
            </el-col>
          </el-row>
          <el-row class="mb40">
            <RichText ref="richText" v-if="user_questions_show" v-model="questionsInfo.forest_desc" />
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="user_questions_show = false">取 消</el-button>
            <el-button type="primary" @click="submitInfo">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import PutQuestions from "./interaction/PutQuestions";	//我要提问
import Answer from "./interaction/Answer";	//我要提问
import RichText from '@/components/RichText/index';
export default {
  name: 'Discuss',
  components: {
  	PutQuestions,
  	Answer,
    RichText
  },
  props:['active','courseId','teacherOpenCourseChatLogId'],
  data() {
    return {
      user:require("../../../images/user/user.png"),
      comment:require("../../../images/course/comment@2x.png"),
      activeName: this.active || 'tab_1',
      textarea:"",
      discussList:[],

      total: 0,
      limit:8,
      page:1,
      problemInfo:{},
      onIndex:0,
      user_questions_show:false,
      questionsInfo:{},
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    handleClick(tab, event){
      console.log(tab.name)
    },
    discussionRecord(){ //查看历史讨论
      this.$router.push({name:'DiscussionRecord',query:{courseId:this.courseId}});
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){
      let param = {
        limit:1,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        chatLogSendTypePlural:"discuss",
        teacherOpenCourseChatLogId:this.teacherOpenCourseChatLogId
      }
      this.$post("/api/teacherOpenCourseChatLog/treeList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          if(!this.$isEmpty(ret.data) && ret.data.length > 0){
            this.problemInfo = ret.data[0];
            this.discussList = [ret.data[0]];
            if(!this.$isEmpty(ret.data[0].children) && ret.data[0].children.length >0){
               this.discussList = this.discussList.concat(ret.data[0].children);
            }
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addComment(){ //发表评论
      if(this.$isEmpty(this.problemInfo.teacherOpenCourseChatLogId)){
        this.$message({message: '暂无讨论内容！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(this.textarea)){
        this.$message({message: '请输入讨论内容！',type: 'warning'});
        return;
      }
      let param = {
        chatLogSendType:"normal",
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseChatLogParentId:this.problemInfo.teacherOpenCourseChatLogId,
        studentId:this.$ls.get(this.$getKeyInfo("identityInfo")).studentId, //学生ID
        chatContent:this.textarea, //讨论内容
      }
      this.$postJSON("/api/teacherOpenCourseChatLog/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.textarea = "";
          this.getInfo();
          this.$message({message: '提交成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    delInfo(item){ //删除
      this.$confirm('是否确定删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/jlw/teacherOpenCourseChatLog/delete.json",{ids:item.teacherOpenCourseChatLogId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功!'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({type: 'info',message: '已取消'});
      });
    },
    lookReply(item){ //查看回复
      this.questionsInfo = {};
      this.questionsInfo.chatContent = item.chatContent;
      this.questionsInfo.teacherOpenCourseChatLogParentId = item.teacherOpenCourseChatLogId;
      this.user_questions_show = true;
    },
    submitInfo(){ //打开提问对话框
      if(this.$isEmpty(this.questionsInfo.forest_desc)){
        this.$message({message: '请输入回复内容！',type: 'warning'});
        return;
      }
      let param = {
        teacherOpenCourseId:this.courseId,
        chatContent:this.questionsInfo.forest_desc,
        chatLogSendType:"student_ask",
        teacherOpenCourseChatLogParentId:this.questionsInfo.teacherOpenCourseChatLogParentId,
      }
      this.$postJSON("/api/teacherOpenCourseChatLog/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.user_questions_show = false;
          this.$message({message: '提交成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    onSuccess_t(){ //回答后，调用父及重载
      this.$emit("onSuccess_t");
    }
  },
  watch:{
    // 被侦听的变量active
    active:{
      handler: function (val, newVal) {
        this.activeName = this.active;
      }
    }
  }
};
</script>
<style  lang="less">
  .course_Discuss{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .el-tabs__nav-wrap::after{
        background-color:white;
      }
      .user_discuss_img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
      .user_discuss_img_{
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .tl_list{
      padding: 20px 20px 20px 0;
    }
    .tl_list:first-child{
      // border-bottom:none;
      border-bottom: 1px solid #DEDEDE;
    }
    .listInfo_p,.chatContentInfo,.user_questions{
      p{
        padding: 0;
        margin: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/Discuss.vue